import { DisabledPrompt, Link } from '@bcm-dev/bcms-vite';
import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView } from 'components/shared/views/TableView';
import React from 'react';
import { SVGAsset } from 'res';
import './styles.css';

/**
 * @function OSGStatementTable
 * @param {React.Component} children - Allows us to inject other components/content.
 * @returns {React.Component}
 * @example
 * <OSGStatementTable>
 *    <OSGStatementView />
 * </OSGStatementTable>
 */

export default function OSGStatementTable(props) {
  return (
    <table className="osg-statements-table">
      <TableColumnContainer className="text-left">
          <TableColumnView className="name-column" text="Statement Name"></TableColumnView>
          <TableColumnView className="date-column" text="Statement Date"></TableColumnView>
          <TableColumnView className="search-column" text="" ></TableColumnView>
      </TableColumnContainer>
      <TableBody>
        {props.children}
      </TableBody>
    </table>
  )
}

/**
 * @function OSGStatementView
 * @param {React.Component} link - Allows us to inject a Link component.
 * @param {String} accountNickname - String to show the Account Nickname.
 * @param {String} accountNumber - String to show the Account Last Four Numbers.
 * @param {String} documentName - String to show the document name.
 * @param {String} documentType - String to show the document type.
 * @param {String} id - The id of the document for creating data-points
 * @returns {React.Component}
 * @example
 * <OSGStatementTable>
 *    <OSGStatementView link={<Link to="/">Link Text</Link>} accountNickname="Checking Account" accountNumber="x1234" documentName="Doc-Name" documentType="pdf" />
 * </OSGStatementTable>
 */

export function OSGStatementView(props) {
  const link = props.link ?? (<Link to="/">[Link]</Link>);
  const documentName = props.documentName ?? "[Document Name]";
  const id = props.id ?? "";
  const showFullColspan = props.showFullColspan ?? false;

return (
  <TableItemContainer>
      { !showFullColspan 
      ? <>
      <TableItemTextView dataPoint={ `Statement_Desktop_Document_${ props.index }` } text={documentName} />
      <TableItemView data-point={ `Statement_Desktop_Item_${ id }` } >{link}</TableItemView>
      <TableItemTextView dataPoint={ `Statement_Desktop_Magnifying_${ props.index }` } text={ <DisabledPrompt><SVGAsset id="MagnifyingGlassIcon" className="clickable"/></DisabledPrompt> } />
      </>
      : <TableItemTextView className="text-center" text={documentName} colSpan="3" /> }
  </TableItemContainer>
);
}